import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { FakVrstaTroska } from './fak-vrsta-troska';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-fak-vrsta-troska-modal-update',
  templateUrl: './fak-vrsta-troska-modal-update.component.html'
})
export class FakVrstaTroskaModalUpdateComponent extends BaseModalUpdateComponent<FakVrstaTroska> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<FakVrstaTroska>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
){
    super(modalContainerService, activeModal,modalService);
}

  ngOnInit() {
  }

}
